import { render } from "./DashboardLayout.vue?vue&type=template&id=7efca92c&scoped=true&ts=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=ts"
export * from "./DashboardLayout.vue?vue&type=script&lang=ts"

import "./DashboardLayout.vue?vue&type=style&index=0&id=7efca92c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7efca92c"]])

export default __exports__